export default __webpack_public_path__ + "static/media/caloIndoorLogoWhite.38013819.svg";